import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { concat, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import {
  ActionsEnum,
  FetchRenewalInfo,
  FetchRenewalInfoError,
  fetchRenewalInfoError,
  FetchRenewalInfoSuccess,
  fetchRenewalInfoSuccess,
  updateRenewalInfo,
  UpdateRenewalInfo,
} from './billing-data.actions';
import { BillingDataService } from './billing-data.service';
import { RenewalInfo } from './models/renewal-info.model';

@Injectable()
export class BillingDataEffects {
  constructor(
    private _actions: Actions,
    private _billingDataService: BillingDataService
  ) {}

  @Effect()
  getRenewalInfo: Observable<
    UpdateRenewalInfo | FetchRenewalInfoSuccess | FetchRenewalInfoError
  > = this._actions.pipe(
    ofType(ActionsEnum.FETCH_RENEWAL_INFO),
    switchMap(({ payload }: FetchRenewalInfo) => {
      const { dispatchId } = payload;

      return this._billingDataService.getAutoRenew().pipe(
        switchMap((renewalInfo: RenewalInfo) =>
          concat([
            updateRenewalInfo(renewalInfo),
            fetchRenewalInfoSuccess(dispatchId),
          ])
        ),
        catchError((error) => of(fetchRenewalInfoError(dispatchId, error)))
      );
    })
  );
}
